import React, { useContext, useEffect, useState } from 'react'
import AddressForm from '../../components/AddressForm'
import ContactForm from '../../components/ContactForm'
import Context from '../../context'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

export default function CourtesyForm() {
  const { editCourtesy, setUser } = useContext(Context)

  const [addressData, setAddressData] = useState({
    zipCode: '',
    address: '',
    number: '',
    neighborhood: '',
    complement: '',
    city: '',
    uf: ''
  })

  const [contactData, setContactData] = useState({
    birth: '',
    cellPhone: '',
    cpf: '',
    email: '',
    hasPrinted: false,
    name: ''
  })

  const [latLong, setLatLong] = useState({
    lat: '',
    long: ''
  })

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
  }, [])

  useEffect(() => {
    setContactData(editCourtesy)
    setAddressData(editCourtesy.address)
  }, [editCourtesy])

  const handleClickSave = async () => {
    const courtesyData = {
      address: { ...addressData, lat: latLong.lat, long: latLong.long },
      birth: contactData.birth,
      cellPhone: contactData.cellPhone,
      cpf: contactData.cpf,
      email: contactData.email,
      hasPrinted: contactData.hasPrinted,
      id: editCourtesy.id,
      name: contactData.name,
      partnerId: editCourtesy.partnerId,
      unityId: editCourtesy.unityId
    }
    // await updateCourtesy(courtesyData);
    history.push('/courtesieslist')
  }

  return (
    <div className="container-fluid">
      <Context.Provider
        value={{
          addressData,
          setAddressData,
          contactData,
          setContactData,
          latLong,
          setLatLong
        }}
      >
        <form
          className="clube-form form-row"
          onSubmit={e => {
            e.preventDefault()
          }}
        >
          <div className="col-12">
            <ContactForm />
            <AddressForm />
          </div>
        </form>
        <div className="col-12">
          <button
            onClick={() => handleClickSave()}
            type="button"
            className="btn clube-button clube-blue"
          >
            Atualizar
          </button>
        </div>
      </Context.Provider>
    </div>
  )
}
